import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(formData.email, formData.password);
      toast.success('¡Bienvenido!');
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);

      let errorMessage = 'Error al iniciar sesión';
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        if (typeof detail === 'string') {
          errorMessage = detail;
        }
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4'>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className='w-full max-w-md'
      >
        <div className='bg-white rounded-2xl shadow-xl p-8 border border-slate-200'>
          <div className='text-center mb-8'>
            <h1 className='text-3xl font-heading font-bold text-slate-900 mb-2'>
              Iniciar Sesión
            </h1>
            <p className='text-slate-600'>
              Accede a tu cuenta de PropiedadesCO
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className='space-y-6'
            data-testid='login-form'
          >
            <div>
              <Label htmlFor='email'>Correo Electrónico</Label>
              <Input
                id='email'
                type='email'
                required
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder='tu@email.com'
                className='mt-2'
                data-testid='email-input'
              />
            </div>

            <div>
              <Label htmlFor='password'>Contraseña</Label>
              <Input
                id='password'
                type='password'
                required
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                placeholder='••••••••'
                className='mt-2'
                data-testid='password-input'
              />
            </div>

            <Button
              type='submit'
              className='w-full bg-primary hover:bg-primary-hover h-12 text-base font-semibold'
              disabled={loading}
              data-testid='login-submit'
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </Button>
          </form>

          <div className='mt-6 text-center'>
            <p className='text-slate-600'>
              ¿No tienes cuenta?{' '}
              <Link
                to='/registro'
                className='text-primary hover:text-primary-hover font-semibold'
                data-testid='register-link'
              >
                Regístrate
              </Link>
            </p>
          </div>

          {/* Demo credentials hint */}
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
